module.exports = __webpack_public_path__ + "static/media/arrow_right.7da2124e.svg";